module.exports = __webpack_public_path__ + "img/6.46dad8a7.jpg";